import { AudioLayerData } from "../layers/audioLayerData.model.tsx";
import { BaseSerializer } from "./baseSerializer.ts";

export class AudioSerializer extends BaseSerializer {
  public deserialize(data: any): any {
    this._normalizeSource(data);
    const gp = new AudioLayerData(data);
    return gp;
  }
}
